var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { SelectCssClass, SelectVRTState, } from '../../../../components/src/components/select/select.types';
import { GlobalCssClass, } from '../../../../components/src/utils/interfaces';
var selectIds = 0;
var IressSelect = /** @class */ (function (_super) {
    __extends(IressSelect, _super);
    function IressSelect(props) {
        var _this = _super.call(this, props) || this;
        _this.selectId = "iress-select-" + selectIds++;
        _this.component = React.createRef();
        _this.nativeInput = React.createRef();
        _this.getStatus = function (newValue) { return ({
            value: newValue ? newValue : _this.state.currentValue,
            element: _this.nativeInput.current
                ? _this.nativeInput.current
                : undefined,
            name: _this.props.name,
            required: _this.props.required,
            error: _this.state.error,
            label: _this.props.multiInputLabel,
        }); };
        _this.updateErrors = function (valMsg) {
            if ((_this.state.error !== '' && valMsg === '') ||
                (_this.state.error === '' && valMsg !== '')) {
                if (_this.nativeInput.current &&
                    _this.nativeInput.current.value !== _this.state.currentValue) {
                    _this.setState({
                        currentValue: _this.nativeInput.current.value,
                    });
                }
                var event_1 = new CustomEvent('iressErrorChange', {
                    bubbles: true,
                    detail: _this.getStatus(),
                });
                // Dispatch the event.
                _this.nativeInput.current &&
                    _this.nativeInput.current.dispatchEvent(event_1);
            }
            _this.setState({ error: valMsg });
        };
        _this.handleEvent = function (event) {
            if (_this.nativeInput.current) {
                if (_this.nativeInput.current.value !== _this.state.currentValue) {
                    _this.setState({ currentValue: _this.nativeInput.current.value });
                }
            }
            event &&
                event(_this.getStatus(_this.nativeInput.current && _this.nativeInput.current.value));
        };
        _this.state = {
            error: '',
            currentValue: props.value ? props.value : '',
        };
        return _this;
    }
    IressSelect.prototype.componentDidMount = function () {
        var _this = this;
        if (this.component.current) {
            // 'Mocking' web component methods
            this.component.current['validate'] = function () {
                _this.nativeInput.current &&
                    _this.updateErrors(_this.nativeInput.current.validationMessage || '');
            };
            this.component.current['getNativeElement'] = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    return [2 /*return*/, Promise.resolve(this.nativeInput
                            .current)];
                });
            }); };
            this.component.current['reset'] = function () { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    this.setState({
                        error: '',
                        currentValue: '',
                    });
                    return [2 /*return*/];
                });
            }); };
        }
        // Register the select with field.
        if (this.nativeInput.current) {
            var selectedOpt = this.nativeInput.current.querySelector("option[value=\"" + this.props.value + "\"]");
            if (selectedOpt)
                selectedOpt.setAttribute('selected', 'selected');
            this.fieldEle = this.nativeInput.current.closest('iress-field');
            if (this.fieldEle && this.fieldEle.registerInputElement) {
                this.fieldEle.registerInputElement(this.getStatus());
            }
        }
    };
    IressSelect.prototype.componentWillUnmount = function () {
        if (this.nativeInput.current && this.fieldEle) {
            this.fieldEle.unregisterInputElement(this.getStatus());
        }
    };
    IressSelect.prototype.render = function () {
        var _this = this;
        var _a = this.props, hiddenLabel = _a.hiddenLabel, multiInputLabel = _a.multiInputLabel, name = _a.name, optional = _a.optional, required = _a.required, vrtState = _a.vrtState, placeholder = _a.placeholder, onChange = _a.onChange, onBlur = _a.onBlur, onFocus = _a.onFocus, children = _a.children, width = _a.width;
        var widthClass = width &&
            SelectCssClass["Width" + width] + " " + SelectCssClass.IgnoreStack;
        return (React.createElement("div", { className: SelectCssClass.Base + " " + GlobalCssClass.FormElement + " " + (this.state.error ? GlobalCssClass.FormElementInvalid : "") + " " + (hiddenLabel ? SelectCssClass.HiddenLabel : "") + " " + (required ? SelectCssClass.Required : "") + " " + (vrtState === SelectVRTState.Focus
                ? SelectCssClass.Focus
                : "") + " " + (width ? widthClass : ''), ref: this.component },
            multiInputLabel && (React.createElement("iress-label", { class: SelectCssClass.Label, for: this.selectId, "label-text": multiInputLabel, required: required, optional: optional })),
            React.createElement("div", { className: SelectCssClass.Wrapper },
                React.createElement("select", { name: name, id: this.selectId, className: SelectCssClass.Select, required: required, onFocus: function () {
                        return onFocus && _this.handleEvent(onFocus);
                    }, onBlur: function () { return onBlur && _this.handleEvent(onBlur); }, onChange: function () {
                        return onChange && _this.handleEvent(onChange);
                    }, ref: this.nativeInput },
                    placeholder && React.createElement("option", { value: "" }, placeholder),
                    children))));
    };
    IressSelect.VRTState = SelectVRTState;
    return IressSelect;
}(React.Component));
export { IressSelect };
//# sourceMappingURL=IressSelect.js.map